import React from 'react'
import './homescreen.css'
import NAV from '../nav/Nav'
import BODY from '../body/Body'

const Homescreen = ({ show, setShow }) => {
  return (
    <div>
      <NAV  show={show} setShow={setShow} />
      <BODY />
      
    </div>
  );
};

export default Homescreen